import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Play, Pause, SkipForward, SkipBack, Map, Volume2, Navigation, MapPin, Clock, CheckCircle } from 'lucide-react';
import logo from './logo.svg';
import './App.css';
import MuseumTour from './MuseumTour';

const App = () => {
  // App state
  const [showCredits, setShowCredits] = useState(true);

  return (
    <div className="App">
      <MuseumTour />
    </div>
  );
}

export default App;
